/**
 * Unterstreichungen der Rechtschreibprüfung über die CSS Custom Highlight API.
 *
 * Highlights sind reine Darstellung über `Range`-Objekte: Sie verändern den
 * Editor-DOM nicht, landen also nie in `getHtml()` bzw. in der gesendeten Mail,
 * lassen den Cursor in Ruhe und stören das Rückgängig-Machen nicht.
 *
 * Die Namen der Highlights sind global (eins je Art). Mehrere offene
 * Verfassen-Fenster tragen deshalb ihre Bereiche hier je Quelle ein; das
 * Register setzt daraus die gemeinsamen Highlights zusammen.
 */

export const HIGHLIGHT_RECHTSCHREIBUNG = "kmvs-rs-rechtschreibung";
export const HIGHLIGHT_GRAMMATIK = "kmvs-rs-grammatik";

type Bereiche = { rechtschreibung: Range[]; grammatik: Range[] };

type HighlightKonstruktor = new (...ranges: Range[]) => object;
type HighlightRegister = { set(name: string, h: object): unknown; delete(name: string): unknown };

const register = (): HighlightRegister | null => {
    const css = (globalThis as { CSS?: { highlights?: HighlightRegister } }).CSS;
    return css?.highlights ?? null;
};
const konstruktor = (): HighlightKonstruktor | null =>
    (globalThis as { Highlight?: HighlightKonstruktor }).Highlight ?? null;

/** Kann dieser Browser Highlights? Edge/Chrome ab 105, Firefox ab 140. */
export const highlightsMoeglich = (): boolean => !!register() && !!konstruktor();

const quellen = new Map<string, Bereiche>();

function zusammensetzen(): void {
    const reg = register();
    const H = konstruktor();
    if (!reg || !H) return;
    const r: Range[] = [];
    const g: Range[] = [];
    for (const b of quellen.values()) {
        r.push(...b.rechtschreibung);
        g.push(...b.grammatik);
    }
    if (r.length) reg.set(HIGHLIGHT_RECHTSCHREIBUNG, new H(...r));
    else reg.delete(HIGHLIGHT_RECHTSCHREIBUNG);
    if (g.length) reg.set(HIGHLIGHT_GRAMMATIK, new H(...g));
    else reg.delete(HIGHLIGHT_GRAMMATIK);
}

export function setzeMarkierungen(quelle: string, bereiche: Bereiche): void {
    quellen.set(quelle, bereiche);
    zusammensetzen();
}

export function entferneMarkierungen(quelle: string): void {
    if (!quellen.delete(quelle)) return;
    zusammensetzen();
}
